import React from 'react';
import { FiAlertTriangle, FiX } from 'react-icons/fi';
import { Button } from '../ui/Button';

interface UnsavedChangesModalProps {
  onConfirm: () => void;
  onCancel: () => void;
}

export const UnsavedChangesModal: React.FC<UnsavedChangesModalProps> = ({
  onConfirm,
  onCancel,
}) => {
  return (
    <div className="fixed inset-0 z-100 flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm">
      <div
        className="w-full max-w-[420px] bg-[#111111] border border-white/10 rounded-[24px] overflow-hidden shadow-2xl"
        style={{ animation: 'fadeInScale 0.2s ease-out' }}
      >
        <div className="p-6">
          <div className="flex items-start justify-between mb-6">
            <div className="w-12 h-12 rounded-xl bg-orange-500/10 flex items-center justify-center text-orange-400 shrink-0">
              <FiAlertTriangle size={24} />
            </div>
            <button
              onClick={onCancel}
              className="p-2 text-zinc-500 hover:text-white transition-colors -mt-1 -mr-1"
            >
              <FiX size={20} />
            </button>
          </div>

          <h3 className="text-white text-xl font-bold mb-2">Discard unsaved changes?</h3>
          <p className="text-zinc-400 text-[15px] leading-relaxed mb-6">
            You have unsaved changes. If you leave now, your edits will be lost.
          </p>

          <div className="flex gap-3">
            <Button
              variant="secondary"
              size="lg"
              className="flex-1 rounded-xl bg-zinc-900 border border-white/10 hover:bg-white/5"
              onClick={onCancel}
            >
              Cancel
            </Button>
            <Button
              size="lg"
              className="flex-1 rounded-xl bg-white text-black hover:bg-zinc-200"
              onClick={onConfirm}
            >
              Discard Changes
            </Button>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes fadeInScale {
          from { opacity: 0; transform: scale(0.95); }
          to { opacity: 1; transform: scale(1); }
        }
      `}</style>
    </div>
  );
};
